import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UsuarioSimple } from '../models/usuario-simple.model';

@Injectable({
    providedIn: 'root'
})
export class UsuariosService {

    constructor(private http: HttpClient) { }

    buscarPorEmail(email: string) {
        return this.http.get<UsuarioSimple>('/usuarios/buscar', {
            params: { email },
            observe: 'response'
        });
    }
}
